const DISPATCH_LOCATION_ERROR_KEYS = [
  'incidentLocationLatitude',
  'incidentLocationLongitude',
  'incidentLocationName',
  'incidentLocationAddress',
  'incidentLocationType',
] as const

export function flattenValidationErrors(errors: Record<string, string[]>): string[] {
  const messages: string[] = []
  for (const key of Object.keys(errors)) {
    const fieldErrors = errors[key]
    if (!Array.isArray(fieldErrors)) continue
    for (const message of fieldErrors) {
      const trimmed = String(message ?? '').trim()
      if (trimmed) messages.push(trimmed)
    }
  }
  return messages
}

export function getDispatchFieldErrors(errors: Record<string, string[]>): string[] {
  const messages: string[] = []
  for (const key of DISPATCH_LOCATION_ERROR_KEYS) {
    const fieldErrors = errors[key]
    if (!Array.isArray(fieldErrors)) continue
    for (const message of fieldErrors) {
      const trimmed = String(message ?? '').trim()
      if (trimmed) messages.push(trimmed)
    }
  }
  return messages
}

export function hasDispatchFieldErrors(errors: Record<string, string[]>): boolean {
  return getDispatchFieldErrors(errors).length > 0
}
